export const vendingData = [
  {
    id: 0,
    customerName: "Emeka Nwachukwu",
    meterNumber: "0102837465",
    tokenNumber: "185638283746152623",
    units: "3.12KVA",
    amount: 15500.0,
    paymentMethod: "Remita",
    invoiceNumber: "1727781881",
    rrr: "4882399239",
    date: "2024-10-2",
    time: "5:30 pm",
    status: 0,
  },
  {
    id: 1,
    customerName: "Aisha Bello",
    meterNumber: "0178264532",
    tokenNumber: "287146836475526789",
    units: "5.28KVA",
    amount: 20000.0,
    paymentMethod: "Wallet",
    invoiceNumber: "1727781881",
    rrr: "4882399239",
    date: "2024-10-2",
    time: "6:10 pm",
    status: 2,
  },
  {
    id: 2,
    customerName: "Chidi Okeke",
    meterNumber: "0164357652",
    tokenNumber: "274818365372625122",
    units: "4.65KVA",
    amount: 18200.0,
    paymentMethod: "Wallet",
    invoiceNumber: "1727781881",
    rrr: "4882399239",
    date: "2024-10-1",
    time: "8:15 am",
    status: 1,
  },
  {
    id: 3,
    customerName: "Yemi Lawal",
    meterNumber: "0127583642",
    tokenNumber: "365716283746152623",
    units: "2.87KVA",
    amount: 12000.0,
    paymentMethod: "Remita",
    invoiceNumber: "1727781881",
    rrr: "4882399239",
    date: "2024-10-2",
    time: "7:30 pm",
    status: 1,
  },
  {
    id: 4,
    customerName: "Fatima Abdul",
    meterNumber: "0102856238",
    tokenNumber: "287436284715362825",
    units: "5.10KVA",
    amount: 25000.0,
    paymentMethod: "Wallet",
    invoiceNumber: "1727781881",
    rrr: "4882399239",
    date: "2024-10-1",
    time: "10:45 am",
    status: 3,
  },
  {
    id: 5,
    customerName: "Ngozi Eze",
    meterNumber: "0153876421",
    tokenNumber: "294718365472526721",
    units: "3.78KVA",
    amount: 19000.0,
    paymentMethod: "Wallet",
    invoiceNumber: "1727781881",
    rrr: "4882399239",
    date: "2024-10-2",
    time: "4:25 pm",
    status: 2,
  },
  {
    id: 6,
    customerName: "Bola Johnson",
    meterNumber: "0172634821",
    tokenNumber: "374619283746152623",
    units: "4.25KVA",
    amount: 22500.0,
    paymentMethod: "Remita",
    invoiceNumber: "1727781881",
    rrr: "4882399239",
    date: "2024-10-1",
    time: "11:00 am",
    status: 1,
  },
];

export const WalletData = [
  {
    id: 0,
    customerName: "John Monday",
    meterNumber: "0172876823",
    amount: 20000.0,
    currentBalance: 205000.0,
    invoiceNumber: "1727781881",
    rrr: "1727781881",
    date: "2024-10-2",
    time: "7:50 pm",
    status: 1,
  },
  {
    id: 1,
    customerName: "Chinaza Okeke",
    meterNumber: "0172876824",
    amount: 15000.0,
    currentBalance: 205000.0,
    invoiceNumber: "1727781882",
    rrr: "1727781882",
    date: "2024-10-2",
    time: "7:55 pm",
    status: 1,
  },
  {
    id: 2,
    customerName: "Adamu Bello",
    meterNumber: "0172876825",
    amount: 30000.0,
    currentBalance: 205000.0,
    invoiceNumber: "1727781883",
    rrr: "1727781883",
    date: "2024-10-2",
    time: "8:00 pm",
    status: 2,
  },
  {
    id: 3,
    customerName: "Funmi Adeyemi",
    meterNumber: "0172876826",
    amount: 10000.0,
    currentBalance: 205000.0,
    invoiceNumber: "1727781884",
    rrr: "1727781884",
    date: "2024-10-2",
    time: "8:05 pm",
    status: 3,
  },
  {
    id: 4,
    customerName: "Emeka Eze",
    meterNumber: "0172876827",
    amount: 50000.0,
    currentBalance: 205000.0,
    invoiceNumber: "1727781885",
    rrr: "1727781885",
    date: "2024-10-2",
    time: "8:10 pm",
    status: 1,
  },
  {
    id: 5,
    customerName: "Fatima Sule",
    meterNumber: "0172876828",
    amount: 25000.0,
    currentBalance: 205000.0,
    invoiceNumber: "1727781886",
    rrr: "1727781886",
    date: "2024-10-2",
    time: "8:15 pm",
    status: 0,
  },
];